/**
 * Action creator for the list of available CPT codes. Consumed by
 * the CPT section in AccountEdit where each service row picks a
 * code from a constrained dropdown (no free-typed duplicates).
 *
 * Endpoint: GET /cpts — returns a flat array of code strings.
 */
export const fetchCptCodesAction = () => ({
  method: 'GET',
  endpoint: '/cpts',
});
